export const DEPENDENCY_CARD_TYPE = 'DEPENDENCY_TYPE';
export const EPIC_CARD_TYPE = 'EPIC_TYPE';
